import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  conversations: {
    loading: true,
    error: null,
    conversations: [],
    total_pages: 1,
    page_number: 1,
  },
  conversation: {
    loading: true,
    error: null,
    conversation: null,
    messages: [],
    documents: [],
  },
};

export const aiProductsSlice = createSlice({
  name: 'aiProducts',
  initialState,
  reducers: {
    getConversationsPending: (state) => {
      state.conversations.loading = true;
      state.conversations.error = null;
    },
    getConversationsRejected: (state, { payload }) => {
      state.conversations.loading = false;
      state.conversations.error = payload;
    },
    getConversationsSuccess: (state, { payload }) => {
      state.conversations.loading = false;
      state.conversations.conversations = payload.data;
      state.conversations.total_pages = payload.total_pages;
      state.conversations.page_number = payload.current_page;
    },
    resetConversationsState: (state) => {
      state.conversations = { ...initialState.conversations };
    },
    getConversationPending: (state) => {
      state.conversation.loading = true;
      state.conversation.error = null;
    },
    getConversationRejected: (state, { payload }) => {
      state.conversation.loading = false;
      state.conversation.error = payload;
    },
    getConversationSuccess: (state, { payload }) => {
      state.conversation.loading = false;
      state.conversation.conversation = payload.conversation;
      state.conversation.messages = payload.messages;
      state.conversation.documents = payload.documents;
    },
    resetConversationState: (state) => {
      state.conversation = { ...initialState.conversation };
    },
  },
});

export default callerCreator(aiProductsSlice.actions);
